import { useCallback, useEffect, useState } from 'react';
import { API } from '@service';
import {
  getAverageColumnsWidthRatio,
  getMaxColumnIndex,
} from '@components/textContainer/helper';
import cloneDeep from 'lodash/cloneDeep';
// import { deepCopy } from '@utils';

const initialData = {
  data: { contents: [], columnsWidthRatio: [] },
};
const useTextContainerService = (textContainerId, isTemplate = false) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(cloneDeep(initialData));

  const saveData = async (dataToSave) => {
    setLoading(true);
    try {
      const fetcher = isTemplate
        ? API.saveTextContainerTemplate
        : API.saveTextContainer;
      const sendData = { ...dataToSave };
      if (sendData?.data !== null && typeof sendData.data !== 'string') {
        sendData.data = JSON.stringify(sendData.data);
      }
      const result = await fetcher(sendData);
      if (result.data?.id) {
        const nextData = {
          ...dataToSave,
          id: result.data?.id,
        };
        setData(nextData);
        setLoading(false);
        return nextData;
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  const fetchData = useCallback(async (textContainerId) => {
    setLoading(true);
    try {
      const fetcher = isTemplate
        ? API.getTextContainerTemplate
        : API.getTextContainer;
      const res = await fetcher(textContainerId);
      if (res) {
        if (typeof res?.data === 'string') {
          res.data = JSON.parse(res.data);
        }
        if (Array.isArray(res.data)) {
          // add column width to old data for compatibility
          res.data = {
            contents: res.data,
            columnsWidthRatio: getAverageColumnsWidthRatio(res.data),
          };
        } else if (
          getMaxColumnIndex(res.data?.contents) + 1 !==
            res.data?.columnsWidthRatio?.length &&
          res.data?.columnsWidthRatio
        ) {
          res.data.columnsWidthRatio = getAverageColumnsWidthRatio(res.data);
        }
        setData(res?.data ? res : cloneDeep(initialData));
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (textContainerId) {
      fetchData(textContainerId);
    } else {
      setData(cloneDeep(initialData));
    }
  }, [textContainerId]);

  return {
    data,
    fetchData,
    saveData,
    loading,
  };
};

export default useTextContainerService;
